import { useState, useEffect} from "react";
import {
  Button,
  Input,
  Space,
  Spin
} from "antd";
import createImagePromptGPT from "./controller/createImagePromptGPT";

const SentenceImageRight_ = (
  {
    imageConfig,
  }
) => {
  const [input, setInput] = useState("")
  const [output, setOutput] = useState("")
  const [loading, setLoading] = useState(false)
  const [tip, setTip] = useState([])
  const [count, setCount] = useState(0)

  const createMeaningPrompt = () => {
    setLoading(true)
    createImagePromptGPT(input, imageConfig.gpt_model)
    .then(newPrompt=>{
      setOutput(newPrompt)
    })
    .catch(err=>{
      console.log(err)
    })
    .finally(()=>{
      setTip([])
      setLoading(false)
      setCount(0)
    })
  }

  useEffect(() => {
    if (loading) {
      const codeTime = setInterval(() => {
        if(count < 6) {
          const newTip = tip.slice()
          newTip.push("忍..")
          setTip(newTip)
          setCount(count + 1)
        } else {
          setCount(count + 20)
          setTip(["忍"])
        }
      }, 1000);
      return () => {
        clearInterval(codeTime);
      };
    }
  });

 

  return (
    <Spin spinning={loading} tip={
      <div>
        {tip.map((el,idx)=>{
          let size = 0
          if(count < 7) {
            size = 20 + (idx * count)
          } else {
            size = 50 + (count)
          }
          // console.log(size)
          return (
            <span key={idx} style={{fontWeight:"bold", color: count < 7 ? "black" : "red", fontSize: `${size}px`}}>{el}</span>
          )
        })}
      </div>
    }>
      <Space direction="vertical" style={{width:"100%"}}>
        <Input.TextArea
          style={{height:"150px"}}
          value={input}
          onChange={(e)=>setInput(e.target.value)}
        ></Input.TextArea>
        <Button onClick={createMeaningPrompt}>GPT야.. 빨리 좀 하자!</Button>
        <div>{`${imageConfig.gpt_model}로 진행중입니다.`}</div>
        <Input.TextArea
          style={{height:"300px"}}
          value={output}
          onChange={(e)=>setInput(e.target.value)}
        ></Input.TextArea>
      </Space>
    </Spin>
  )
};

export default SentenceImageRight_;